import { Icon } from './Icons.jsx';
import Avatar from './Avatar.jsx';

// Menu de conta — bottom sheet acessado pelo ícone de perfil no topo do fluxo
export default function AccountMenu({ open, onClose, onNavigate, onLogout, profile }) {
  if (!open) return null;

  const items = [
    { key: 'orders', label: 'Meus Pedidos', icon: 'file' },
    { key: 'results', label: 'Meus Resultados', icon: 'flask' },
    { key: 'profile', label: 'Editar Perfil', icon: 'user' },
  ];

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 200 }}>
      <div onClick={onClose} style={{ position: 'absolute', inset: 0, background: 'var(--overlay-navy-45)' }}/>
      <div className="bottom-sheet" style={{
        background: 'var(--white)', borderRadius: '20px 20px 0 0',
        padding: '20px 20px 28px', boxShadow: '0 -20px 50px var(--overlay-navy-25)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, paddingBottom: 16, borderBottom: '1px solid var(--border)', marginBottom: 8 }}>
          <Avatar user={profile} size={48}/>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 15, color: 'var(--midnight)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {profile?.first_name} {profile?.last_name}
            </div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {profile?.email}
            </div>
          </div>
          <button onClick={onClose} aria-label="Fechar" style={{ marginLeft: 'auto', color: 'var(--text-muted)', padding: 4 }}>
            <Icon.x size={20}/>
          </button>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {items.map(it => {
            const IC = Icon[it.icon];
            return (
              <button key={it.key} onClick={() => onNavigate(it.key)} style={{
                display: 'flex', alignItems: 'center', gap: 12, padding: '13px 8px',
                fontSize: 14.5, fontWeight: 600, color: 'var(--midnight)', fontFamily: 'var(--font-display)',
                borderRadius: 10,
              }}>
                <span style={{ width: 34, height: 34, borderRadius: 9, background: 'var(--marble-soft)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <IC size={17} color="var(--midnight)"/>
                </span>
                {it.label}
                <Icon.chevR size={16} color="var(--text-subtle)" style={{ marginLeft: 'auto' }}/>
              </button>
            );
          })}
          <button onClick={onLogout} style={{
            display: 'flex', alignItems: 'center', gap: 12, padding: '13px 8px', marginTop: 6,
            fontSize: 14.5, fontWeight: 600, color: 'var(--danger)', fontFamily: 'var(--font-display)',
            borderRadius: 10,
          }}>
            <span style={{ width: 34, height: 34, borderRadius: 9, background: 'var(--overlay-danger-08)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Icon.logout size={17} color="var(--danger)"/>
            </span>
            Sair da conta
          </button>
        </div>
      </div>
    </div>
  );
}
